import { render, staticRenderFns } from "./DashInventoryDeadlineReview.vue?vue&type=template&id=7e746fed&scoped=true&"
import script from "./DashInventoryDeadlineReview.vue?vue&type=script&lang=js&"
export * from "./DashInventoryDeadlineReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e746fed",
  null
  
)

export default component.exports